// العناصر والتبويبات المدمجة في مساحة العمل الذكية، التي يضعها مصمم المساحة إلى جانب الصفحات.
export default {
  spaceBuiltins: {
    noPlaybooks: "يلزم إضافة الأدلة الإجرائية في تبويب القدرات أولا.",
    playbookDefault: "تبويبات الدليل الإجرائي",
    playbookNone: "لا يضيف هذا الدليل الإجرائي أي تبويبات.",
    moveUp: "نقل لأعلى",
    moveDown: "نقل لأسفل",
    remove: "إزالة",
    widget: {
      "ask": { name: "السؤال", hint: "مربع الكتابة مع أربعة أسئلة للبدء؛ يفتح السؤال محادثة، ويحال البحث إلى باحث الأدلة." },
      "start-work": { name: "بدء العمل", hint: "العمليات الرئيسية لمساحة العمل، لكل منها الغرض والمخرجات والمدة المعتادة ومثال." },
      "my-work": { name: "عملك", hint: "ملفات العضو المفتوحة مع المرحلة الحالية والخطوة التالية والموعد." },
      "needs-decision": { name: "بانتظار قرارك", hint: "مقترحات مساحة العمل هذه التي تنتظر المراجعة، مع رابط إلى صندوق الوارد." },
      "economy-strip": { name: "الاقتصاد في لمحة", hint: "ستة مؤشرات رئيسية مع حداثتها، ورابط إلى الأدلة." },
      "launchers": { name: "نقاط البدء", hint: "بدء دراسة اقتصاد جديد أو دراسة اقتصادية أو سياسة، مع مطالبات بحثية جاهزة." },
      "economic-pulse": { name: "النبض الاقتصادي", hint: "المؤشرات الرئيسية لدولة الإمارات مع دور المصدر وحداثة البيانات والمنحنى المصغر والمقارنة الدولية." },
      "national-targets": { name: "المستهدفات الوطنية", hint: "آخر قيمة مقابل كل مستهدف وطني، والوتيرة المطلوبة مقابل الوتيرة الأخيرة، مع أساس القياس." },
      "release-calendar": { name: "الإصدارات والمراجعات", hint: "الإصدارات المتوقعة خلال أسبوعين والمراجعات التي تمس معاملات مفتوحة." },
      "portfolio-board": { name: "لوحة المحفظة", hint: "عمليات مساحة العمل في مسارات حسب المرحلة، مع حلقات المواعيد وما ينتظر المستخدم." },
      "evidence-health": { name: "سلامة الأدلة", hint: "وضع كل مصدر إحصائي وآخر تحديث له وما إذا كان قديما أو محجوبا." },
      "horizon-radar": { name: "رادار الأفق", hint: "إشارات الاقتصاد الجديد من المنشورات الدولية المستوعبة حديثا، حسب المحور." },
    },
    tab: {
      brief: "الموجز",
      evidence: "الأدلة",
      foresight: "الاستشراف",
      options: "الخيارات",
      consultation: "التشاور",
      draft: "المسودة",
      delivery: "التنفيذ",
      assurance: "الضمان",
      outputs: "المخرجات",
      links: "الروابط",
    },
  },
};
